/**
 * Datos iniciales para crear bloqueos a empresas.
 *
 * @returns object
 */
export const defaultCompanyBlockade = () => {
    return {
        type: null,
        slq_company_id: null,
        description: null,
    };
};

/**
 * Valores por defecto para el buscaro de bloqueos.
 *
 * @return {Object}
 */
export const defaultHistoryFilter = () => {
    return {
        paginado: true,
        page: 1,
        perPage: 15,
        sortBy: "created_at",
        sort: "desc",
    };
};

/**
 * Carga todas las variables declaradas en el proceso.
 */
export default {
    modal: {
        show: false,
    },
    action: null,
    company: null,
    companyBlockades: [],
    companyBlockade: defaultCompanyBlockade(),
    filter: defaultHistoryFilter(),
};
